<template>
    <div>
        <ion-header>
            <ion-toolbar>
                <ion-title>{{ title || $t('ncrypt.register') }}</ion-title>
                <ion-buttons slot="end">
                    <ion-button @click="closeModal()"> {{ $t('ncrypt.close') }}</ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
            <h3>{{ intro || this.$t('ncrypt.register_your_account') }}</h3>
            <register-form v-on:registered="onRegisterFromModal" v-on:register-error="onRegisterError" :initialEmail="initialEmail"/>
        </ion-content>
    </div>
</template>

<script>
    import RegisterForm from "./RegisterForm";
    import {ApiError} from "../../errors/ApiError";

    export default {
        name: "RegisterModal",
        components: {
            RegisterForm,
        },
        props: {
            title: {
                type: String,
                default: undefined,
            },
            intro: {
                type: String,
                default: undefined,
            },
            initialEmail: {
                type: String,
                default: undefined,
            },
        },
        methods: {
            onRegisterFromModal(data) {
                this.closeModal();
            },
            onRegisterError(data) {
                new ApiError(data, true);
            },
            closeModal() {
                this.$ionic.modalController.dismiss();
            }
        },
    }
</script>
